import moment from 'moment'
export default {
  dates: {
    isGreater15(elapsed) {
      let _result = false
      try {
        if (elapsed !== null && elapsed !== undefined) {
          if (elapsed.indexOf('day') > 0) {
            _result = true
          } else if (elapsed.indexOf('hour') > 0) {
            _result = true
          } else if (elapsed.indexOf('minutes') > 0) {
            let _temp = elapsed.split(' ')
            let _mins = parseInt(_temp[0])
            if (_mins > 15) {
              _result = true
            }
          }
        }
      } catch (e) { }
      return _result
    },
    elapsedTime(time, status, woStatus) {
      // console.log('Elapsed Time', {
      //   time: time,
      //   userStatus: status,
      //   workOrderStatus: woStatus
      // })
      if (woStatus !== null) {
        if (['closed', 'voided ro', 'completed', 'cancelled'].indexOf(woStatus.toLowerCase()) > -1) {
          return null
        }
      } else {
        return null
      }
      // Resource: http://jsfiddle.net/cckSj/5/
      if (status !== null) {
        if (['closed', 'voided ro', 'scan completed', 'cancelled'].indexOf(status.toLowerCase()) > -1) {
          return null
        }
      } else {
        return null
      }
      // Time when the change was made on database (database time)
      let startTime = new Date(time)
      // Current time (user time)
      // IMPORTANT: I'm adding a minute since seems like PROD DB has 12 seconds behind of difference making it to display a negative -1 minute instead of 0 minutes.
      let endTime = new Date(
        moment()
          .add(1, 'minutes')
          .utcOffset('-06:00')
          .format('YYYY-MM-DD HH:mm:ss')
      )
      // time difference in ms
      let timeDiff = endTime - startTime
      // strip the miliseconds
      timeDiff /= 1000
      // get seconds
      // let seconds = Math.round(timeDiff % 60)
      // remove seconds from the date
      timeDiff = Math.floor(timeDiff / 60)
      // get minutes
      let minutes = Math.round(timeDiff % 60)
      // remove minutes from the date
      timeDiff = Math.floor(timeDiff / 60)
      // get hours
      let hours = Math.round(timeDiff % 24)
      // remove hours from the date
      timeDiff = Math.floor(timeDiff / 24)
      // the rest of timeDiff is number of days
      let days = timeDiff
      let timeElapsed = ''
      // Show day(s)
      if (days > 0) {
        timeElapsed = days === 1 ? days + ' day, ' : days + ' days, '
      }
      // Show Hours
      if (hours > 0) {
        timeElapsed +=
          hours > 0 ? (hours === 1 ? hours + ' hour ' : hours + ' hours ') : ' '
      }
      // Show Minutes
      // Since we aren't displaying seconds we have the following problem:
      // Sometimes, seconds equals to ~59 and minutes equals to 0.
      // So, in that case, "x minutes" won't be display at the DOM because it's 0. To fix this, we'll set minutes to 1 if it's actually 0.
      // With this, even if minutes equals 0 (really ~59 seconds), it will be displayed as "1 minute"
      minutes = minutes === 0 ? 1 : minutes
      if (minutes > 0) {
        timeElapsed +=
          minutes === 1 ? minutes + ' minute ' : minutes + ' minutes '
      }
      // Update object
      return timeElapsed
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/global.js